import { createSelector } from 'reselect';

const data = (state) => state.picklistDetailsData;

export const selectCurrentPicklistData = () =>
  createSelector([data], (state) => state.currentPicklist);

export const selectPicklistStatusesData = () =>
  createSelector([data], (state) => state.picklistStatuses);

export const selectCountingData = () => createSelector([data], (state) => state.assetsCounting);

export const selectPicklistAssetsData = () => createSelector([data], (state) => state.assets);

export const selectPicklistLooseItemsData = () =>
  createSelector([data], (state) => state.looseItems);

export const selectPicklistAssembliesData = () =>
  createSelector([data], (state) => state.assemblies);

export const selectFilterData = () => createSelector([data], (state) => state.filter);

export const selectFilterChipsData = () => createSelector([data], (state) => state.chips);

export const selectFilterCriteriaData = () => createSelector([data], (state) => state.criteria);
